//import SVGA from 'svgaplayerweb';
export default {
  install(Vue, options) {
    // 时间转换为时间戳
    Vue.prototype.date2timestamp = function(datetime) {
      datetime = datetime.replace(/-/g, "/");
      let timestamp = new Date(Date.parse(datetime));
      timestamp = timestamp.getTime();
      timestamp = timestamp / 1000;
      return timestamp;
    };
    //获取年月日
    Vue.prototype.formatDate = function(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    };
    // 交互函数传参
    // par1 ios
    // par2 android
    Vue.prototype.params = function(par1, par2, functionName) {
      console.groupCollapsed("调用原生方法：", functionName);
      console.log("ios", par1);
      console.log("android", par2);
      console.groupEnd();
      let ua = navigator.userAgent.toLowerCase();
      if (par1 == "") {
        if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
          window.webkit.messageHandlers[functionName].postMessage(null);
        } else if (/android/i.test(ua)) {
          window.AndroidToast[functionName]("success");
        }
      } else {
        if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
          window.webkit.messageHandlers[functionName].postMessage(par1);
        } else if (/android/i.test(ua)) {
          window.AndroidToast[functionName](par2);
        }
      }
    };
    //会员昵称加密
    Vue.prototype.nicknameHandle = function($name) {
      if ($name.length <= 0) {
        $name = "***";
      } else if ($name.length == 1) {
        $name = $name;
      } else if ($name.length == 2) {
        $name = $name.substring(0, 1) + "*";
      } else if ($name.length == 3) {
        $name = $name.substring(0, 1) + "**";
      } else if ($name.length == 4) {
        $name =
          $name.substring(0, 1) +
          "*" +
          $name.substring($name.length - 2, $name.length);
      } else {
        $name =
          $name.substring(0, 1) +
          "**" +
          $name.substring($name.length - 2, $name.length);
      }
      return $name;
    };
    // 判断当前设备是否是IphoneX
    Vue.prototype.isIphoneX = function() {
      // let isiOS1 = /iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375);
      // let isiOS2 = /iphone/gi.test(navigator.userAgent) && (screen.height == 896 && screen.width == 414);
      // let isiOS = isiOS1 || isiOS2;
      let isiOS = /iphone/gi.test(navigator.userAgent) && screen.height >= 812;
      return isiOS;
    };
    //数字小于10补0  (6=>06)
    Vue.prototype.checkTime = function(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    };
    Vue.prototype.openApp = function(type, code, parmSrc) {
    
      var u = navigator.userAgent;
      //var isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      //android端
      if (isAndroid) {
        //安卓app的scheme协议
        window.location.href = "xblife://" + parmSrc;
        setTimeout(function() {
          let hidden =
            window.document.hidden ||
            window.document.mozHidden ||
            window.document.msHidden ||
            window.document.webkitHidden;
          if (typeof hidden == "undefined" || hidden == false) {
            if (type == "register") {
              window.location.href = "/share?" + code;
            } else {
              window.location.href = "/load";
            }
          }
        }, 2000);
      }
      //ios端
      if (isIOS) {
        //ios的scheme协议
      
        window.location.href = "ShallBuyLife123://" + parmSrc;
        setTimeout(function() {
          let hidden =
            window.document.hidden ||
            window.document.mozHidden ||
            window.document.msHidden ||
            window.document.webkitHidden;
          if (typeof hidden == "undefined" || hidden == false) {
            if (type == "register") {
              window.location.href = "/share?" + code;
            } else {
              window.location.href = "/load";
            }
          }
        }, 2000);
      }
    };
    // 二维数组
    Vue.prototype.arrTrans = function(num, arr) {
      if (!Array.isArray(arr)) {
        return [];
      }
      const newArr = [];
      while (arr.length > 0) {
        newArr.push(arr.splice(0, num));
      }
      return newArr;
    };
    //	    ,
    //		Vue.prototype.SVGA = function(fileUrl, svgaElement, loops, stop){
    //	      let player = new SVGA.Player(svgaElement)
    //	      let parser = new SVGA.Parser(svgaElement)
    //	      parser.load(fileUrl, function (videoItem) {
    //	        player.loops = loops // 设置循环播放次数是 1
    //	        player.setVideoItem(videoItem)
    //	        player.stepToFrame(0, true) // 从指定帧开始播放动画
    //	        if(stop) {
    //      		player.clearsAfterStop = false;
    //      	}
    ////	        player.onFrame((i) => {
    ////
    ////	          console.log(i) // 。这里输入的是动画的帧数
    ////	          if (i >= 24 && i < 26) {
    ////	            console.log('111')
    ////	          } else if (i >= 70) {
    ////	            player.clear()
    ////	          }
    ////	        })
    //	      })
    //	    }

    /**
     * 友盟统计
     * @param {*} eventName 事件ID
     */
    Vue.prototype.invokeStat = function(eventName) {
      if (eventName) {
        this.params(eventName, eventName, "invokeStat");
      }
    };
    /**
    * 加载外部js
    * @param {*} src
    */
     Vue.prototype.loadJS = function(src) {
      if (!Array.isArray(src)) {
        src = [src];
      }
      return Promise.all(
        src.map((_) => {
          return new Promise((resolve, reject) => {
            let script = document.createElement("script");
            script.type = "text/javascript";
            script.src = _;
            document.body.appendChild(script);

            script.onload = () => {
              resolve();
            };
            script.onerror = () => {
              reject();
            };
          });
        })
      );
    };
  },
};
